import z from 'zod';
import { NeedDto } from './need.dto';

const SuggestedNeedSchema = z.object({
  type: z.literal('need'),
  tempNeedId: z.string().nullable(),
  issueId: z.number().optional().nullable(),
  reason: z.string().optional().nullable(),
});

export type SuggestedNeedDto = Omit<
  z.infer<typeof SuggestedNeedSchema>,
  'type'
> & {
  callId: number;
  id?: string;
  suggestedActions?: SuggestedActionDto[];
  isAccurateSuggestion?: boolean;
  accuracyIssues?: string[];
  accuracyFeedback?: string;
  deletedAt?: number;
  needId?: number;
};

const SuggestedActionSchema = z.object({
  type: z.literal('action'),
  tempNeedId: z.string().optional().nullable(),
  needId: z.number().optional().nullable(),
  activityId: z.number(),
  description: z.string().optional().nullable(),
});

export type SuggestedActionDto = Omit<
  z.infer<typeof SuggestedActionSchema>,
  'type'
> & {
  id?: string;
  callId: number;
  need?: NeedDto | SuggestedNeedDto;
  isAccurateSuggestion?: boolean;
  accuracyIssues?: string[];
  accuracyFeedback?: string;
  deletedAt?: number;
  actionId?: number;
};

const SuggestedScheduledEventSchema = z.object({
  type: z.literal('scheduled_event'),
  eventType: z.string(),
  note: z.string().optional().nullable(),
  date: z.string().optional().nullable(),
  time: z.number().optional().nullable(),
  visitLocation: z.string().optional().nullable(),
  visitLocationAddressId: z.number().optional().nullable(),
});

export type SuggestedScheduledEventDto = Omit<
  z.infer<typeof SuggestedScheduledEventSchema>,
  'type'
> & {
  type: string;
  callId: number;
  id?: string;
  isAccurateSuggestion?: boolean;
  accuracyIssues?: string[];
  accuracyFeedback?: string;
  deletedAt?: number;
  scheduledEventId?: number;
};

export const CreateVoiceCallSuggestionsRequestSchema = z.object({
  suggestions: z.array(
    z.discriminatedUnion('type', [
      SuggestedNeedSchema,
      SuggestedActionSchema,
      SuggestedScheduledEventSchema,
    ])
  ),
});

export type CreateVoiceCallSuggestionsRequest = z.infer<
  typeof CreateVoiceCallSuggestionsRequestSchema
>;

export type SuggestionsDto = {
  needs: SuggestedNeedDto[];
  actions: SuggestedActionDto[];
  scheduledEvents: SuggestedScheduledEventDto[];
};

export const SuggestionAccuracyFeedbackRequestSchema = z.object({
  isAccurateSuggestion: z.boolean(),
  suggestionAccuracyFeedback: z.string().optional().nullable(),
  suggestionAccuracyIssues: z.array(z.string()).optional().nullable(),
  type: z.enum(['need', 'action', 'scheduled_event']),
});

export type SuggestionAccuracyFeedbackRequest = z.infer<
  typeof SuggestionAccuracyFeedbackRequestSchema
>;
